module.exports = __webpack_public_path__ + "img/22.2.TN.58270cd4.png";